import { useMutation } from "@tanstack/react-query";
import ENDPOINTS from "utils/requests/endpoints";
import axiosInstance from "utils/requests/axiosInstance";

export const getHeader = async () => {
  const response = await axiosInstance.get(
    process.env.REACT_APP_CSRF_URL + ENDPOINTS.getHeader
  );
  return response;
};

const useGetHeader = () => {
  //   const router = useRouter();

  return useMutation({
    mutationFn: getHeader,
    onError(error: any) {
      // showSnackBar(error?.data?.data?.messages?.authentication, "error");
    },
  });
};

export default useGetHeader;
